import {
  CopyAll,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@mui/icons-material";
import {
  Button,
  Collapse,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SingleTransctionViewer from "./SingleTransctionViewer";
import SingleDateSummaryViewer from "./SingleDateSumaryViewer";

const SingleDateTransctionViewer = ({
  date,
  transctions,
  file,
  balances,
  dTransId,
  onDeleteTransaction,
}) => {

  console.log(balances)
  const [isOpen, setIsOpen] = useState(false);
  const [copyText, setCopyText] = useState("Copy");
  const [downloadText, setDownloadText] = useState("Download");

  const onCopyText = (isDownload) => {
    // excelGenerator({ date: bookings }, accountFormatter, file, isDownload);
    isDownload ? setDownloadText("Downloaded") : setCopyText("Copied");
    setTimeout(() => {
      isDownload ? setDownloadText("Download") : setCopyText("Copy");
    }, 2000);
  };

  const onToggle = () => {
    setIsOpen((p) => !p);
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          flexGrow: 1,
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Button
          onClick={onToggle}
          disableRipple
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            textTransform: "none",
          }}
        >
          <Typography
            variant="h6"
            color="primary.main"
            sx={{ fontSize: "14px" }}
          >
            {date}
          </Typography>

          {isOpen ? (
            <KeyboardArrowUp sx={{ marginLeft: "20px" }} />
          ) : (
            <KeyboardArrowDown sx={{ marginLeft: "20px" }} />
          )}
        </Button>

        <div
          style={{
            marginRight: "30px",
          }}
        >
          <Tooltip title={downloadText} placement="left">
            <IconButton
              sx={{
                marginRight: "20px",
              }}
              onClick={() => {
                onCopyText(true);
              }}
            >
              <ArrowDownwardIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={copyText} placement="right">
            <IconButton
              onClick={() => {
                onCopyText(false);
              }}
            >
              <CopyAll />
            </IconButton>
          </Tooltip>
        </div>
      </Stack>
      <SingleDateSummaryViewer date={date} balances={balances} />
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <div style={{ marginLeft: "10px" }}>
          {transctions.map((transction) => {
            return (
              <SingleTransctionViewer
                Transction={transction}
                key={transction._id}
                dTransId={dTransId}
                onDeleteTransaction={onDeleteTransaction}
              />
            );
          })}
        </div>
      </Collapse>
    </>
  );
};

// const findSumOfTransction = (transctions) => {
//   return transctions.reduce(
//     (acc, cur) => {
//       return {
//         cash: acc.cash + cur.transction.payment.cash,
//         bank: acc.bank + cur.transction.payment.bank,
//         ota: acc.ota + cur.transction.payment.ota,
//       };
//     },
//     {
//       cash: 0,
//       bank: 0,
//       ota: 0,
//     }
//   );
// };

export default SingleDateTransctionViewer;
